export function BooleanData() {
    return {
        name: "boolean",
        label: "Boolean",
        primitiveType: "boolean",
    };
}

export default BooleanData;
